(function () {
    var units = [].slice.call(document.querySelectorAll(".keyvisual"));
    if (!units.length) return;

    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reducedMotion) return;

    // the Unicorn runtime only starts a scene when WebGL2 is available
    function hasHardwareWebGL2() {
        try {
            var canvas = document.createElement("canvas");
            var gl = canvas.getContext("webgl2", { failIfMajorPerformanceCaveat: true });
            if (!gl) return false;
            var loseContext = gl.getExtension("WEBGL_lose_context");
            if (loseContext) loseContext.loseContext();
            return true;
        } catch (e) {
            return false;
        }
    }

    function pauseWhileOffscreen(kv, video) {
        if (!window.IntersectionObserver) return;
        new IntersectionObserver(function (entries) {
            if (entries[entries.length - 1].isIntersecting) {
                video.play().catch(function () {});
            } else {
                video.pause();
            }
        }).observe(kv);
    }

    function showVideo(kv) {
        if (kv.dataset.kvVideo) return;
        kv.dataset.kvVideo = "1";
        var host = kv.querySelector(".keyvisual__unicorn");
        if (host) host.remove();
        var template = kv.querySelector("template.keyvisual__fallback");
        if (!template) return;
        var video = template.content.querySelector("video").cloneNode(true);
        video.addEventListener("playing", function () {
            kv.classList.add("keyvisual--video-ready");
        }, { once: true });
        kv.appendChild(video);
        pauseWhileOffscreen(kv, video);
    }

    function revealSceneAfterTwoFrames(kv) {
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                kv.classList.add("keyvisual--scene-ready");
            });
        });
    }

    function keepSized(scenes) {
        if (!window.ResizeObserver) return;
        scenes.forEach(function (scene) {
            var el = scene && scene.element;
            if (!el) return;
            var w = el.offsetWidth, h = el.offsetHeight;
            new ResizeObserver(function () {
                var nw = el.offsetWidth, nh = el.offsetHeight;
                if (nw === w && nh === h) return;
                w = nw;
                h = nh;
                if (!nw || !nh) return;
                try { scene.resize(); } catch (e) {}
            }).observe(el);
        });
    }

    var sceneUnits = units.filter(function (kv) { return kv.querySelector(".keyvisual__unicorn"); });
    units.forEach(function (kv) {
        if (sceneUnits.indexOf(kv) === -1) showVideo(kv);
    });
    if (!sceneUnits.length) return;

    var us = window.UnicornStudio;
    if (!us || !us.init || !hasHardwareWebGL2()) {
        sceneUnits.forEach(showVideo);
        return;
    }

    function onSceneFailure() {
        sceneUnits.forEach(showVideo);
    }

    function onScenesStarted(scenes) {
        keepSized(scenes || []);
        sceneUnits.forEach(function (kv) {
            var canvas = kv.querySelector(".keyvisual__unicorn canvas");
            if (!canvas) {
                showVideo(kv);
                return;
            }
            canvas.addEventListener("webglcontextlost", function () { showVideo(kv); });
            revealSceneAfterTwoFrames(kv);
        });
    }

    try {
        Promise.resolve(us.init()).then(onScenesStarted, onSceneFailure);
    } catch (e) {
        onSceneFailure();
    }
})();
